import React from "react";
import { Card, Button, PageHeader, Descriptions, Row, Col, List, Avatar } from "antd";
import { useQuery } from "@apollo/react-hooks";
import { useParams, Link } from "react-router-dom";
import { childGql } from "../../graphql/child";
import avatar from "../../images/avatar.png";

export const Child = () => {
  let { id } = useParams<any>();
  const { loading, data: { child } = { child: {} } } = useQuery<any>(childGql.child, {
    variables: { id },
  });

  return (
    <div>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={child.name}
        extra={[
          <Button size="small" key="3">
            Edit
          </Button>,
        ]}
      >
        <div className="content" style={{ display: "flex" }}>
          <div className="main">
            <Descriptions size="small" column={2}>
              {/* <Descriptions.Item label="Organizer">Organizer</Descriptions.Item>
              <Descriptions.Item label="Time Duration">Time Duration</Descriptions.Item>
              <Descriptions.Item label="Creation Time">
                {moment(community?.createDate).format("YYYY-MM-DD HH:mm:ss")}
              </Descriptions.Item>
              <Descriptions.Item label="Description" span={2}>
                {community?.description}
              </Descriptions.Item> */}
            </Descriptions>
          </div>
          <div className="extra">
            <div
              style={{
                display: "flex",
                width: "max-content",
                justifyContent: "flex-end",
              }}
            >
              {/* <Statistic title="Status" value="Pending" style={{ marginRight: 32 }} /> */}
              {/* <Statistic title="Historic" prefix="$" value={fundraiser?.historic} style={{ marginRight: 32 }} />
              <Statistic title="Suggested" prefix="$" value={fundraiser?.suggested} style={{ marginRight: 32 }} />
              <Statistic title="Target" prefix="$" value={fundraiser?.target} style={{ marginRight: 32 }} /> */}
            </div>
          </div>
        </div>
      </PageHeader>

      <Row gutter={20} style={{ marginTop: 15 }}>
        <Col span={8}>
          <Card title="Parents" size="small">
            <List
              size="small"
              loading={loading}
              dataSource={child?.parents}
              renderItem={(item: any) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={<Avatar src={avatar} />}
                    title={<Link to={`/users/${item.id}`}>{item.name}</Link>}
                    description={<span>{item.email}</span>}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card title="School" size="small">
            {/* <List
              size="small"
              loading={loading}
              dataSource={child?.communities}
              renderItem={(item: any) => <List.Item>{item.name}</List.Item>}
            /> */}
          </Card>
        </Col>
        <Col span={8}>
          <Card title="..." size="small"></Card>
        </Col>
      </Row>

      {/* {showSubDlg && (
        <SubOrgDlg
          model={model}
          onClose={() => {
            setShowSubDlg(false);
            refetch();
          }}
        /> */}
    </div>
  );
};
